export default "__VITE_ASSET__B8WzQ4Y8__"